import { render, staticRenderFns } from "./UserPermissionsEdit.vue?vue&type=template&id=76a72b0d"
import script from "./UserPermissionsEdit.vue?vue&type=script&lang=js"
export * from "./UserPermissionsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports